import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { VibeCodingHeroSection } from "@/components/insights/vibe-coding/VibeCodingHeroSection";
import { VibeCodingTakeaway } from "@/components/insights/vibe-coding/VibeCodingTakeaway";
import { VibeCodingFounderQuote } from "@/components/insights/vibe-coding/VibeCodingFounderQuote";
import { VibeCodingKeyFindings } from "@/components/insights/vibe-coding/VibeCodingKeyFindings";
import { VibeCodingTools } from "@/components/insights/vibe-coding/VibeCodingTools";
import { VibeCodingBestPractices } from "@/components/insights/vibe-coding/VibeCodingBestPractices";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const VibeCodingGuide = () => {
  return (
    <>
      <InsightSEO 
        slug="vibe-coding-guide" 
        additionalKeywords={["AI coding", "Cursor AI", "Claude", "Bolt.new", "prompt-driven development", "AI pair programming"]}
      />
      <InsightEngagementTracker slug="vibe-coding-guide" title="Vibe Coding Guide" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="AI Development" 
          currentPage="Vibe Coding Guide" 
        />
        <VibeCodingHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <VibeCodingTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <VibeCodingFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <VibeCodingKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <VibeCodingTools />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <VibeCodingBestPractices />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="vibe-coding-guide" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="vibe-coding-guide" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="vibe-coding-guide" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default VibeCodingGuide;
